module.exports = __webpack_public_path__ + "img/icon-change-payment-mode.3a06a1b6.svg";